import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Actions,
  Container,
  LinkButton,
  LinksContainer,
  Main,
  ReportContent,
  Title,
  TopButton,
} from './impact.style';
import { Button } from '../../../components/uielements';

const Impact = () => {
  const navigate = useNavigate();

  const handleNavigateToReviewLodge = () => {
    navigate('/reviewAndLodge');
  };
  return (
    <Container>
      <TopButton>IMPACT ASSESSABLE</TopButton>
      <Title>Impact Assessable Applications</Title>

      <Main>
        <ReportContent>
          <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
          <li>Sed tempor leo ac nisl tempus, nec bibendum enim ultrices.</li>
          <li>
            Duis libero dolor, vestibulum quis libero vel, dapibus mollis eros. Pellentesque risus
            nibh, faucibus ut volutpat eu, tristique ut enim.
          </li>
          <li>
            Nulla condimentum dignissim pellentesque. Pellentesque habitant morbi tristique senectus
            et netus et malesuada fames ac turpis egestas.
          </li>
          <li>Sed tempor leo ac nisl tempus, nec bibendum enim ultrices.</li>
          <li>
            Duis libero dolor, vestibulum quis libero vel, dapibus mollis eros. Pellentesque risus
            nibh, faucibus ut volutpat eu, tristique ut enim.
          </li>
        </ReportContent>
      </Main>

      <Actions>
        <Button onClick={handleNavigateToReviewLodge}>REVIEW & LODGE</Button>
        <LinksContainer>
          <LinkButton href="#">Email Copy</LinkButton>
          <LinkButton href="#">Start New Project</LinkButton>
        </LinksContainer>
      </Actions>
    </Container>
  );
};

export default Impact;
